import TwoColumnBlock from './TwoColumnBlock';

export default TwoColumnBlock;
